import { useState } from 'react';
import './App.css';

function App() {
  function normalize(value, elementId) {
    if (["ip", "mac", "user"].includes(elementId)) {
      value = value.replaceAll(" ", ";")
    }

    if (["analysis", "type"].includes(elementId)) {
      return value.trim();
    }

    return value.split(/[;,]+/).filter(v => {
      return v !== '';
    }).map(v => {
      return v.trim();
    }).join(', ');
  }

  function get(elementId) {
    let result = normalize(document.getElementById(elementId).value, elementId);
    if (result.length === 0) {
      return null;
    }
    return result;
  }

  function isPresent(arr) {
    if (Array.isArray(arr)) {
      return !arr.every((e) => e === null);
    }
    return arr !== null;
  }

  function getText(textName) {
    switch (textName) {
      case 'microsoft-edge-remove-extension': return 'The Microsoft Edge application appears to be attempting DNS resolutions for malicious domains. This is likely due to a malicious browser add-on. For instructions on how to remove browser add-ons, please visit https://helpcenter.trendmicro.com/en-us/article/tmka-10374';
      case 'microsoft-edge-uninstall': return 'The Microsoft Edge application appears to be attempting DNS resolutions for malicious domains. Use the steps below to uninstall the application, including its profile data.\n\nNote: You may need to backup certain items to prevent data loss. Please be cautious while doing so as you may accidentally backup malware.\n1. Using Microsoft Edge, visit the URL “edge://version” and take note of the “Executable path”, “Profile path”, and “Microsoft Edge” (version) entries.\n2. Quit Microsoft Edge and ensure it is no longer running. Check for other running Microsoft Edge processes as additional ones such as updaters are known to launch during device logon.\n3. Open Command Prompt. You can do this through pressing the Windows key and “r” at the same time then entering “cmd.exe” in the popup followed by pressing “OK”.\n4. Navigate to the parent directory of the executable using the “Executable path”. For example, if the “Executable path” is “C:\\Program Files (x86)\\Microsft\\Edge\\Application\\msedge.exe”, type use the command “cd C:\\Program Files (x86)\\Microsoft\\Edge\\Application” in command prompt.\n5. Navigate to your Microsoft Edge version’s directory. For example, if the “Microsoft Edge” entry recorded earlier is “100.0.0000.00”, use the command “cd 100.0.0000.00”. If needed, to list files and folders in the current directory, use the command “dir”.\n6. Enter the installer directory using the command “cd Installer”.\n7. To uninstall Microsoft Edge, type the command “setup.exe --uninstall --system-level --verbose-logging --force-uninstall”.\n8. Ensure that Microsoft Edge profiles have been fully removed. Using File Explorer, navigate to the profile directory if it exists. If it exists:\n8.1. Navigate to the “Microsoft” directory by clicking on the last “Microsoft” folder in the path.\n8.2. Delete or relocate the “Edge” folder. If you receive an error, ensure that all Microsoft Edge processes have been halted. Else, you may need to forcefully delete it from the command line.\n\nIf you need to install Microsoft Edge again, please ensure that it is downloaded directly from Microsoft’s website and only download necessary add-ons from trusted vendors.';
      case 'google-chrome-remove-extension': return 'The Google Chrome application appears to be attempting DNS resolutions for malicious domains. This is likely due to a malicious browser extension. For instructions on how to remove browser extensions, please visit https://helpcenter.trendmicro.com/en-us/article/tmka-10374';
      case 'google-chrome-uninstall': return 'The Google Chrome application appears to be attempting DNS resolutions for malicious domains. Use the steps below to uninstall the application, including its profile data.\n\nNote: You may need to backup certain items to prevent data loss. Please be cautious while doing so as you may accidentally backup malware.\n1. Using Google Chrome, visit the URL “chrome://version” and take note of the “Profile path”.\n2. Quit Google Chrome and ensure it is no longer running. Check for other running Google Chrome processes as additional ones such as updaters are known to launch during device logon.\n3. Uninstall Google Chrome using the official instructions at https://support.google.com/chrome/answer/95319. If presented, ensure that profile data is also removed. Else, malware may linger in the installation.\n4. Ensure that Google Chrome profiles were removed.\n- Windows: Open File Explorer and navigate to the “Profile path”. If you successfully navigate to it, click on the last instance of “Google” in the list of folders. Delete or relocate the “Chrome” folder.\n- MacOS: Open Finder and navigate to the “Profile path” by clicking “Go” in the application menu then choose the “Go to Folder…” option. Paste the “Profile path” into the popup provided and remove all folders from the path after the last “Google”. For instance, if your “Profile path” is “/Users/administrator/Library/Application Support/Google/Chrome/Default”, navigate to “/Users/administrator/Library/Application Support/Google”. Delete or relocate the “Chrome” folder.\n\nIf you need to install Google Chrome again, please ensure that it is downloaded directly from Google’s website and only download necessary plugins from trusted vendors. Do not use an existing installer.';
      case 'google-chrome-sync': return 'Please note that if Google Chrome Sync is in use, malware may reappear or transfer to other machines. We recommend that a separate account is used for Institute-related purposes. To view or clear Google Chrome Sync data, visit https://chrome.google.com/sync.';
      default: return '';
    }
  }

  function buildText() {
    const textItems = [];
    const macros = ['microsoft-edge-remove-extension', 'microsoft-edge-uninstall', 'google-chrome-remove-extension', 'google-chrome-uninstall', 'google-chrome-sync'];
    for (let i = 0; i < macros.length; i += 1) {
      if (isChecked(macros[i])) {
        textItems.push(getText(macros[i]));
      }
    }

    if (textItems.length > 0) {
      return "\n\n" + textItems.join("\n\n") + "\n\n";
    }

    return '';
  }

  function buildArtifact(artifactId) {
    const artifact = {
      name: get("artifactName" + artifactId),
      path: get("artifactPath" + artifactId),
      hash: get("artifactHash" + artifactId),
      verdict: get("artifactVerdict" + artifactId)
    }

    if (isPresent([artifact["name"], artifact["path"], artifact["hash"]])) {
      var artifactLine = artifactCount > 1 ? `Artifact #${artifactId + 1}:` : 'Artifact:';

      if (isPresent(artifact["name"])) {
        artifactLine += `\n- File Name: ${artifact["name"]}`;
      }

      if (isPresent(artifact["path"])) {
        artifactLine += `\n- File Path: ${artifact["path"]}`;
      }

      if (isPresent(artifact["hash"])) {
        let hashLength = artifact["hash"].length;
        var hashType = "File Hash";
        switch (hashLength) {
          case 32: hashType = "MD5"; break;
          case 40: hashType = "SHA1"; break;
          case 56: hashType = "SHA244"; break;
          case 64: hashType = "SHA256"; break;
          case 96: hashType = "SHA384"; break;
          case 128: hashType = "SHA512"; break;
          default: break;
        }

        artifactLine += `\n- ${hashType}: ${artifact["hash"]}`;
      }

      if (isPresent(artifact["verdict"])) {
        artifactLine += `\n- Verdict: ${artifact["verdict"]}`;
      }

      return artifactLine + '\n\n';
    }

    return '';
  }

  function isChecked(elementId) {
    return document.getElementById(elementId).checked;
  }

  function buildActions() {
    var build = "";
    if (isChecked("action-advise")) {
      build += "\n- Please advise on the sensitivity of the data on the machine.\n- If the machine has or has access to \"Protected\" data, let us know as soon as possible.\nReference: https://security.gatech.edu/DataCategorization";
    }

    if (isChecked("action-uninstall-unapproved")) {
      build += "\n- Uninstall unapproved software and use an Institute-approved alternative."
    }

    if (isChecked("action-remove-email")) {
      build += "\n- Locate the malicious email and remove it from the user's inbox.";
    }

    if (isChecked("action-vulnerable")) {
      build += "\n- Uninstall the vulnerable software. Alternatively, you may submit a policy exception at: b.gatech.edu/policy-exception";
    }

    if (isChecked("action-rebuild")) {
      build += "\n- Rebuild the identified system\n*Manual removal of the infection may not fully remediate the compromise.";
    }

    if (build.length > 0) {
      build = "Action Items:" + build + "\n\n";
    }

    return build;
  }

  function generateResult() {
    var vars = {
      hostname: get("hostname"),
      ip: get("ip"),
      mac: get("mac"),
      user: get("user"),
      type: get("type"),
      analysis: get("analysis"),
      source: get("source")
    };

    let subjectIdentifierElements = isPresent(vars["ip"]) ? vars["ip"].split(', ') : [];
    if (isPresent(vars["hostname"])) {
      subjectIdentifierElements.unshift(vars["hostname"].includes(' ') ? '"' + vars["hostname"] + '"' : vars["hostname"])
    }
    document.getElementById("subject").value = `${isPresent(vars["source"]) ? vars["source"] : "Endpoint Detection"}: ${isPresent(vars["type"]) ? vars["type"] : "Threat"} identified on ${subjectIdentifierElements.length > 0 ? subjectIdentifierElements.join("/") : "Host"}`

    var body = "";

    // Header Line
    // Grammaticalize
    if (!isPresent(vars["type"])) {
      vars["type"] = "a threat";
    }

    var postadd = [];
    if (vars["type"].toLowerCase().includes("keygen")) {
      postadd.push("Use of this software is illegal under the Digital Millennium Copyright Act (DMCA) and inconsistent with the Georgia Institute of Technology Acceptable Use Policy: http://policylibrary.gatech.edu/information-technology/acceptable-use-policy\n\n");
    }

    if (vars["type"].toLowerCase().includes("keylog")) {
      postadd.push("Keyloggers are known to record keystrokes in order to acquire sensitive information such as passwords and billing information.\n\n");
    }

    if (vars["type"].toLowerCase().includes("bruteforce")) {
      postadd.push("Bruteforce attacks are commonly used by attackers to gain unauthorized system access.\n\n");
    }

    var prefix = "";
    switch (vars["type"].toLowerCase().split(" ")[0]) {
      case "trojan": case "worm": case "keylogger": case "keygen": case "vulnerable": case "bruteforce": case "vulnerability": prefix = "a "; break;
      case "unsafe": case "outbound": prefix = "an "; break;
      default: break;
    }
    body += `We have discovered what appears to be ${prefix + vars['type'].toLowerCase()} on an Institute-owned machine.${vars["type"].toLowerCase().includes("unapproved") ? " Please identify the use case for this software and determine how approved software can be used instead." : ""}\n\n`

    body += postadd.join('');

    if (vars['analysis'] !== null) {
      body += `Analysis and Findings: ${vars["analysis"]}\n\n`
    }

    if (isPresent([vars['hostname'], vars['ip'], vars['mac'], vars['user']])) {
      body += "Host:";
      if (isPresent(vars["hostname"])) {
        body += `\n- Hostname${vars["hostname"].includes(", ") ? "s" : ""}: ${vars["hostname"]}`;
      }

      if (isPresent(vars["ip"])) {
        body += `\n- IP Address${vars["ip"].includes(", ") ? "es" : ""}: ${vars["ip"]}`;
      }

      if (isPresent(vars["mac"])) {
        body += `\n- MAC Address${vars["mac"].includes(", ") ? "es" : ""}: ${vars["mac"]}`;
      }

      if (isPresent(vars["user"])) {
        body += `\n- User${vars["user"].includes(", ") ? "s" : ""}: ${vars["user"]}`;
      }

      body += '\n\n';
    }

    body += buildText();

    for (var i = 0; i < artifactCount; i += 1) {
      body += buildArtifact(i);
    }

    let actionItems = buildActions();
    body += actionItems;

    body += `If you believe this to be a false positive, please let us know as soon as possible so that we can further investigate.${isChecked("flag-malware") ? "\n\nIf this is legitimate activity due to malware research, you must fill out a policy exception or external network access may be blocked. Please visit the following link to do so: b.gatech.edu/policy-exception" : ""}`;

    if (actionItems.length > 0) {
      body += "\n\nPlease update us when these action items have been completed and let us know if you have any questions or concerns.";
    } else {
      body += "\n\nLet us know if you have any questions or concerns.";
    }

    if (isChecked("flag-signature")) {
      body += "\n\nThank you,\nGeorgia Tech Cyber Security\nsoc@security.gatech.edu\nhttps://security.gatech.edu\n404-385-2927";
    }

    document.getElementById("result").value = body;
  }

  const [artifactCount, setArtifactCount] = useState(1);

  function newArtifact() {
    let newArtifactContainer = document.createElement("div");
    let title = document.createElement("h4");
    title.innerText = "Artifact #" + (artifactCount + 1);
    newArtifactContainer.appendChild(title);
    [
      {id: "artifactName", placeholder: "Artifact Name", label: "Name", extras: []},
      {id: "artifactPath", placeholder: "Artifact Path", label: "Path", extras: []},
      {id: "artifactHash", placeholder: "Artifact Hash", label: "Hash", extras: []},
      {id: "artifactVerdict", placeholder: "Artifact Verdict", label: "Verdict", extras: [{attr: "list", value: "verdict"}]}
    ].forEach(function (item) {
      // Create Entry Container
      let innerContainer = document.createElement("div");
      innerContainer.classList.add("entry");

      let label = document.createElement("label");
      label.setAttribute("for", item["id"] + artifactCount);
      label.innerHTML = item["label"];

      let input = document.createElement("input");
      input.setAttribute("type", "text");
      input.setAttribute("id", item["id"] + artifactCount);
      input.setAttribute("data-type", "entry");
      input.setAttribute("placeholder", item["placeholder"]);

      item["extras"].forEach(function (extras) {
        input.setAttribute(extras["attr"], extras["value"]);
      });

      innerContainer.appendChild(label);
      innerContainer.appendChild(input);

      newArtifactContainer.appendChild(innerContainer);
    });

    document.getElementById("artifacts").appendChild(newArtifactContainer);

    setArtifactCount(artifactCount + 1);
  }

  return (
    <div className="App">
      <header className="App-header">
        <div>
          <div>
            <h2>Ticket Details</h2>
            <p>
              Only one host is supported. Multiple IP/MAC<br/>
              addresses and users can be specified using a<br/>
              space, semicolon, or comma to delimit them.
            </p>
            <h3>Host</h3>
            <div className="entry">
              <label htmlFor="hostname">Hostname(s)</label>
              <input type="text" id="hostname" placeholder="Hostname(s)" data-type="entry" />
            </div>
            <div className="entry">
              <label htmlFor="ip">IP Address(es)</label>
              <input type="text" id="ip" placeholder="IP Address(es)" data-type="entry" />
            </div>
            <div className="entry">
              <label htmlFor="mac">MAC Address(es)</label>
              <input type="text" id="mac" placeholder="MAC Address(es)" data-type="entry" />
            </div>
            <div className="entry">
              <label htmlFor="user">User(s)</label>
              <input type="text" id="user" placeholder="User(s)" data-type="entry" />
            </div>
            <h3>Malware Analysis</h3>
            <div className="entry">
              <label htmlFor="source">Source</label>
              <input type="text" id="source" placeholder="Source" data-type="entry" list="sources" defaultValue="Endpoint Detection" />
              <datalist id="sources">
                <option>Endpoint Detection</option>
                <option>Network Monitoring</option>
                <option>Email</option>
                <option>Phone</option>
                <option>System Logs</option>
                <option>Threat Intelligence</option>
                <option>Walk-in</option>
              </datalist>
            </div>
            <div className="entry">
              <label htmlFor="type">Type</label>
              <input type="text" id="type" list="malware-types" placeholder="Malware Type" data-type="entry" />
              <datalist id="malware-types">
                <option>Adware</option>
                <option>Spyware</option>
                <option>Trojan</option>
                <option>Worm</option>
                <option>Keylogger</option>
                <option>Botnet &amp; CnC Activity</option>
                <option>Ransomware</option>
                <option>Malware</option>
                <option>Rootkit</option>
                <option>Keygen</option>
                <option>Unapproved Malware and Device Performance Software</option>
                <option>Unapproved Remote Desktop Software</option>
                <option>Unapproved Anti-Virus</option>
                <option>Suspicious Executable</option>
                <option>Suspicious Network Activity</option>
                <option>Potentially Unwanted Program</option>
                <option>Potentially Insecure Software</option>
                <option>Deprecated Software</option>
                <option>Malicious Behavior</option>
                <option>Malicious Email Attachment Access</option>
                <option>Vulnerable Driver</option>
                <option>Vulnerable Executable</option>
                <option>Vulnerable Tunnel</option>
                <option>Unsafe Driver</option>
                <option>Unsafe Executable</option>
                <option>Vulnerability</option>
                <option>Obsolete Software</option>
                <option>Obsolete Driver</option>
                <option>Obsolete Executable</option>
                <option>Misconfigured Software</option>
                <option>Bruteforce Attack</option>
                <option>Outbound Denial of Service Attack</option>
              </datalist>
            </div>
            <div className="entry">
              <label htmlFor="analysis">Analysis</label>
              <textarea id="analysis" data-type="entry" placeholder="Analysis"></textarea>
            </div>
            <h3>Artifacts</h3>
            <div id="artifacts">
            <datalist id="verdict">
                <option>Malicious</option>
                <option>Suspicious</option>
                <option>Benign</option>
                <option>Unsafe</option>
                <option>Deprecated</option>
                <option>Unapproved</option>
                <option>Hack Tool</option>
              </datalist>
              <div>
                <h4>Artifact #1</h4>
                <div className="entry">
                  <label htmlFor="artifactName0">Name</label>
                  <input type="text" id="artifactName0" data-type="entry" placeholder="Artifact Name" />
                </div>
                <div className="entry">
                  <label htmlFor="artifactPath0">Path</label>
                  <input type="text" id="artifactPath0" data-type="entry" placeholder="Artifact Path" />
                </div>
                <div className="entry">
                  <label htmlFor="artifactHash0">Hash</label>
                  <input type="text" id="artifactHash0" data-type="entry" placeholder="Artifact Hash" />
                </div>
                <div className="entry">
                  <label htmlFor="artifactVerdict0">Verdict</label>
                  <input type="text" id="artifactVerdict0" data-type="entry" list="verdict" placeholder="Artifact Verdict" />
                </div>
              </div>
            </div>
            <button className="submit" onClick={newArtifact}>(+) Add New Artifact</button>
            <h3>Action Items</h3>
            <input type="checkbox" id="action-advise" defaultChecked={true} />
            <label htmlFor="action-advise">Advise on Sensitivity of Data</label>
            <br/>
            <input type="checkbox" id="action-uninstall-unapproved" />
            <label htmlFor="action-uninstall-unapproved">Uninstall Unapproved Software</label>
            <br/>
            <input type="checkbox" id="action-remove-email" />
            <label htmlFor="action-remove-email">Remove Malicious Email From Inbox</label>
            <br/>
            <input type="checkbox" id="action-vulnerable" />
            <label htmlFor="action-vulnerable">Uninstall Vulnerable Software or Submit Policy Exception</label>
            <br/>
            <input type="checkbox" id="action-rebuild" />
            <label htmlFor="action-rebuild">Rebuild System</label>
            <h3>Flags</h3>
            <input type="checkbox" id="flag-malware" defaultChecked={true} />
            <label htmlFor="flag-malware">Malware Research Notice</label>
            <br />
            <input type="checkbox" id="flag-signature" defaultChecked={true} />
            <label htmlFor="flag-signature">Security Operations Center Signature</label>
            <h3>Instructions</h3>
            <input type="checkbox" id="microsoft-edge-remove-extension" defaultChecked={false} />
            <label htmlFor="microsoft-edge-remove-extension">Microsoft Edge: Remove Add-ons</label>
            <br />
            <input type="checkbox" id="microsoft-edge-uninstall" defaultChecked={false} />
            <label htmlFor="microsoft-edge-uninstall">Microsoft Edge Uninstall (Windows)</label>
            <br />
            <input type="checkbox" id="google-chrome-remove-extension" defaultChecked={false} />
            <label htmlFor="google-chrome-remove-extension">Google Chrome: Remove Extensions</label>
            <br />
            <input type="checkbox" id="google-chrome-uninstall" defaultChecked={false} />
            <label htmlFor="google-chrome-uninstall">Google Chrome: Uninstall</label>
            <br />
            <input type="checkbox" id="google-chrome-sync" defaultChecked={false} />
            <label htmlFor="google-chrome-sync">Google Chrome: Sync Notice</label>
          </div>
          <div>
            <h2>Result</h2>
            <button className="submit" onClick={generateResult}>Generate Ticket</button>
            <input type="text" id="subject" placeholder="Subject" />
            <textarea id="result" placeholder="Body"></textarea>
          </div>
        </div>   
        <p>Created by Jayson Fong</p>     
        <p><a className="App-link" href="https://email-checker.jaysonfong.org/" target="_blank" rel="noreferrer">Email Checker</a> | <a className="App-link" href="#Private-Service">Security Searchboard</a></p>
      </header>
    </div>
  );
}

export default App;
